/*!jslint
  this
*/
jQuery(function ($) {
  "use strict";

  $(document).on("click", ".nav-toggle", function (e) {
    $(".nav-toggle-in").toggleClass("on");
    $("html").toggleClass("nav-open");
  });

  function appHeight() {
    var wh = $(window).innerHeight();
    document.documentElement.style.setProperty("--app-height", wh + "px");
  }
  window.addEventListener("resize", appHeight);
  appHeight();

  function setHeaderHeight() {
    $("html").css("--header-height", $(".site-header").outerHeight() + "px");
  }
  setHeaderHeight();

  $(".about-cl").slick({
    dots: false,
    arrows: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    cssEase: "linear",
  });

  gsap.registerPlugin(ScrollTrigger);

  const items = document.querySelectorAll(".hm-banner-in-feature");

  items.forEach((item, index) => {
    const next = items[index + 1];
    if (!next) return;

    ScrollTrigger.create({
      trigger: next,
      start: "top 70%",
      end: "top 40%",
      scrub: true,
    });
  });
  ScrollTrigger.create({
    trigger: ".hm-banner",
    start: "top top",
    end: "bottom top",
    pin: ".hm-banner-video",
    scrub: true,
    pinSpacing: false,
  });

  $('a[href^="#"]')
    .not("a.enquiry-form")
    .on("click", function (e) {
      const target = $(this.hash);
      if (!target.length) return;
      e.preventDefault();
      $("html, body")
        .stop()
        .animate(
          {
            scrollTop: target.offset().top - $("header").outerHeight(),
          },
          0
        );
    });

  // $(".enquiry-form").magnificPopup({
  //   type: "inline",
  //   midClick: true,
  // });
    var originalForm = $('#popup-form').html();
    $('.enquiry-form').magnificPopup({
        type: 'inline',
        midClick: true,
        callbacks: {
            beforeOpen: function() {
                $('#popup-form').html(originalForm);
            }
        }
    });

});

